export default __webpack_public_path__ + "static/media/logo-blue.a7cc1694.png";